module.exports = __webpack_public_path__ + "static/img/Milestones.c8357ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Milestones.png
// module id = xRnU
// module chunks = 1